import React, {useEffect, useRef, useState} from 'react';
import './checkbox.scss';
import {generateUniqueId} from "../../../app/functions";

const HtmlCheckbox = (props) => {
    const [checked, setChecked] = useState(false);
    const containerRef = useRef(null);
    const clickedLinks = useRef(new Set());

    const handleOnChange = (e) => {
        if (e) {
            e.stopPropagation();
        }
        if (!disableCheckbox) {
            const isChecked = value !== '' ? value : checked;
            props.onChange(!isChecked);
            setChecked(!isChecked);
        } else {
            onDisabledClicked();
        }
    };

    const {
        name,
        label = '',
        value = '',
        showError = false,
        errorMessage = '',
        tabIndex,
        id = ('id' + Math.floor(Math.random() * 10000000)),
        className = '',
        html = '',
        checked_img = '',
        not_checked_img = '',
        onLabelClick = () => {},
        handleLinkClick = () => {},
        onAllLinksClicked = () => {},
        disableCheckbox,
        onDisabledClicked = () => {},
    } = props;

    const handleLabelClick = (e) => {
        if (e) {
            e.stopPropagation();
        }
        setChecked(!checked)
        typeof onLabelClick === 'function' && onLabelClick();
    };

    useEffect(() => {
        const container = containerRef.current;
        if (!container) return;

        const links = container.querySelectorAll('a');
        const totalLinks = links.length;

        const handleLinkClick = (event) => {
            event.preventDefault();
            event.stopPropagation()

            clickedLinks.current.add(event.target);

            const url = event.currentTarget.href
            const hrefAttribute = event.currentTarget.getAttribute('href')
            if (hrefAttribute) {
                window.open(url, '_blank', 'noopener,noreferrer');
            }

            if (clickedLinks.current.size === totalLinks) {
                onAllLinksClicked();
            }
        };

        if (props.handleLinkClick) {
            links.forEach(link => {
                link.addEventListener('click', props.handleLinkClick);
            });

            return () => {
                links.forEach(link => {
                    link.removeEventListener('click', props.handleLinkClick);
                });
            };
        } else {
            links.forEach(link => {
                link.addEventListener('click', handleLinkClick);
            });

            return () => {
                links.forEach(link => {
                    link.removeEventListener('click', handleLinkClick);
                });
            };
        }
    }, [html, onAllLinksClicked]);

    const isChecked = value !== '' ? value : checked
    const isTemplate = typeof label === 'string' && label.match(/\{([^}]+)\}/g);
    const newLabel = isTemplate ? getTemplate() : label;

    return (
        <div className={'checkbox_wrapper ' + className}>
            <img
                src={isChecked ? checked_img : not_checked_img}
                alt=""
                onClick={handleOnChange}
                style={{cursor: disableCheckbox ? 'not-allowed' : 'pointer'}}
            />
            <input
                type={'checkbox'}
                name={name}
                id={id}
                value={value}
                onChange={handleOnChange}
                tabIndex={tabIndex}
            />
            <label
                htmlFor={id}
                onClick={handleLabelClick}
                style={{cursor: disableCheckbox ? 'not-allowed' : 'pointer'}}
            >
                {newLabel}
            </label>
            <div
                className='checkbox-html-container'
                ref={containerRef}
                onClick={handleLabelClick}
                dangerouslySetInnerHTML={{__html: html}}
            />
            {showError ? <div className="error_text">{errorMessage}</div> : ''}
        </div>
    )
}
export default HtmlCheckbox;

